import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/dedupe';
import './stylesheets/Tr.scss';

export default class Tr extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hovered: false
    };

    this.hover = () => this.setState({ hovered: true });
    this.blur = () => this.setState({ hovered: false });
  }

  render() {
    const { columns, data, disabled, onClick } = this.props;
    const renderValue = (row, column) => {
      const { key, format, component } = column;

      if (component && typeof component === 'function') {
        return component(row);
      } else if (format && typeof format === 'function') {
        return format(row[key]);
      }

      return row[key];
    };

    const renderColumn = (column, index) => {
      const classes = {
        numeric: column.type === 'number'
      };
      if (column.tdClassName) { classes[column.tdClassName] = true; }
      return (
        <td key={index} className={classNames(classes)}>
          { renderValue(data, column) }
        </td>
      );
    };
    const classes = { loc: true, disabled, hovered: this.state.hovered };

    return (
      <tr className={classNames(classes)} onMouseOver={this.hover} onMouseLeave={this.blur} onClick={onClick}>
        { columns.map(renderColumn) }
      </tr>
    );
  }
}

Tr.propTypes = {
  columns: PropTypes.array.isRequired, // eslint-disable-line
  data: PropTypes.object.isRequired, // eslint-disable-line
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/Tr.jsx